import {Controller} from "stimulus"
import $ from 'jquery';


export default class extends Controller {

    connect() {
        let context = this;
        this.search = $(`#${this.element.dataset.search_input}`);
        this.input_type = this.element.dataset.find
        this.anidation_level = this.element.dataset.level
        console.log(this.input_type);
        console.log(this.anidation_level);
        console.log(this.search);

        if (this.search.length > 0) {
            this.search.on('keyup', function () {
                let search_input_by_type = $(context.element).find(context.input_type)
                if (search_input_by_type.length > 0) {
                    search_input_by_type.map((index, input) => {
                        let parent = $(input)[0].parentElement
                        switch (parseInt(context.anidation_level)) {
                            case 0:
                                parent = $(input)[0]
                                break;
                            case 2:
                                parent = parent.parentElement
                                break;
                        }

                        console.log(parent)
                        console.log(input.innerText.toLowerCase())
                        console.log(context.search.val().toLowerCase())
                        console.log(input.innerText.toLowerCase().includes(context.search.val().toLowerCase()))
                        console.log(parent.className)
                        if (!input.innerText.toLowerCase().includes(context.search.val().toLowerCase())) {
                            parent.classList.add('ocultar');
                        } else {
                            parent.classList.remove('ocultar');
                        }
                    })
                }
            })
        }
    }

}